<div class="page-content">
    <div class="row">
        <div class="col-lg-12">
            <div class="ibox ">
                <div class="ibox-body">
                    <div class="iboxcontent">
                        <h3>Post Job</h3>
                        <div class="stepsnumber">
                            <span>Steps 4/5</span>
                        </div>
                    </div>
                    <h6 class="heading-6">  Screening questions</h6>
                    <p>We recommend adding 3 or more questions. Applicants must answer each question</p>

                    <div class="row">
                        <div class="col-sm-12 col-lg-12 col-md-12">
                            <div class="form-group">
                                <h6 class="heading-6">Add Screening question</h6>
                            </div>
                            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                                
                                <div class="questiondiv" *ngFor="let ques of addedQuestion; let i=index;">
                                    <h5 class="question"> <span><a href="javascript:void(0)" (click)="deleteQues(i)"><img src="assets/images/ic_close.svg"></a></span></h5>
                                    <div class="row">
                                        <div class="col-sm-6 col-lg-6 col-md-6">
                                            <div class="form-group">
                                                <label>{{ques.title}}</label>
                                                <br>
                                                <label>{{ques.answer}}</label> 
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-lg-6 col-md-6">
                                            <div class="form-group">
                                                <label>Response Type</label>
                                                <br>
                                                <label>{{ques.responseType == 0 ? "Yes/No" :"Text"}}</label> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div formArrayName="addCustomQuestion">
                                    <div *ngFor="let add of getCusQuestion(); let i=index">
                                        <div [formGroupName]="i"> 
                                            <div class="questiondiv">
                                                <h5 class="question">Write custom screening question. <span><a href="javascript:void(0)" (click)="deleteQuestion(i)"><img src="assets/images/ic_close.svg"></a></span></h5>
                                                <p>  Help keep Honorvet respectful and professional. Learn about our <span class="orange"> custom questions guidelines</span></p>
                                                <div class="form-group">
                                                    <textarea type="text" class="form-control" placeholder="Try asking a question like, ‘Will you be able to bring your own device’?"  formControlName="title" maxlength="250"></textarea>
                                                    <p class="para5">{{add.value.title.length}}/250</p>
                                                </div>
                                                <div class="text-danger" *ngIf="showError">*Please add Question</div>
                                                <div class="row">

                                                    <div class="col-sm-6 col-lg-6 col-md-6">
                                                        <div class="form-group">
                                                            <label>Response type</label>
                                                            <select class="form-control" formControlName="responseType" [(ngModel)]="selectedValue" (ngModelChange)="changeResponse($event,i)">
                                                                <option value="0">Yes/No</option>
                                                                <option value="1">Text</option>
                                                            </select>
                                                        </div>
                                                    </div>


                                                    <div class="col-sm-6 col-lg-6 col-md-6" *ngIf="selectedValue == 0" hidden>
                                                        <div class="form-group">
                                                            <label>Answer</label>
                                                            <select class="form-control" formControlName="answer">
                                                                <option value="Yes">Yes</option>
                                                                <option value="No">No</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-6 col-lg-6 col-md-6" *ngIf="selectedValue == 1">
                                                        <div class="form-group">
                                                            <label>Answer</label>
                                                            <input type="text" class="form-control" name="" placeholder="Enter" formControlName="answer" />
                                                        </div>
                                                    </div>
                                                   <div class="col-sm-12">
                                                    <a href="javascript:void(0);" (click)="addQuestion()" class="borderBtn planbtn wdth float-right">Add</a>
                                                   </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!--end  -->
                                <div class="form-group">
                                    <h6 class="heading-6"> Add Screening questions </h6>
                                    <ul class="suggestedskills">
                                        <li *ngFor="let ques of allQuestions; let i=index;" (click)="selectedQuestion(i,$event)" [ngClass]="ques.selected == true ? 'selected' : ''">{{ques.question}}</li>
                                        <li class="showmore" (click)="addMoreQuestion()"><a href="javascript:void(0);" style="color: #EF7E2B;">Add custom question</a></li>
                                    </ul>
                                </div>

                                <a href="javascript:void(0);" class="planbtn greyBtn" (click)="back()">Back</a>
                                <input type="submit" value="Continue" class="planbtn fill"/>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>